// MODULE CONSTANTS
/////////////////////////
// Module "constants" can be overridden using config.js

export default {
	/**
	 * items per server fetch in paged assetListViews.
	 * @const
	 * @type {number}
	 * @default
	 */
	CHUNK_SIZE: 40,

	/**
	 * max number of items displayed per page in an assetListView; max length of a Netx.Collections.MiniAssets
	 * @const
	 * @type {number}
	 * @default
	 */
	PAGE_SIZE: 200,

	/**
	 * Display asset collection thumbnails as equal height images in equal height rows
	 * @const
	 * @type {boolean}
	 * @defaul
	 */
	EQUAL_GRID: true,

	/**
	 * AssetListType options
	 * @const
	 * @type {array}
	 * @defaul
	 */
	LIST_TYPE: ['card', 'curator', 'grid', 'list'],

	/**
	 * If enabled all asset list views will be managed by Netx.Views.AssetListViewTypeManager epending on the current LIST_TYPE selected
	 * @const
	 * @type {boolean}
	 * @defaul
	 */
	LIST_TYPES_ENABLED: false,

	/**
	 * default asset list type if user has no preference stored:
	 * @const
	 * @type {array}
	 * @defaul
	 */
	LIST_TYPE_DEFAULT: 'grid',

	/**
	 * id of the DOM element this module installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	ASSETS_CONTAINER_ID: 'assets',

	/**
	 * id of the DOM element the assetDetailView installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	DETAILS_CONTAINER_ID: 'asset-details',

	/**
	 * id of the DOM element the assetVersionsView installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	VERSIONS_CONTAINER_ID: 'asset-versions',

	/**
	 * id of the DOM element the assetZoomView installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	ZOOM_CONTAINER_ID: 'zoom',

	/**
	 * id of the zoom canvas inside the assetZoomView
	 * @const
	 * @type {string}
	 * @default
	 */
	ZOOM_CANVAS_ID: 'zoom-canvas',

	/**
	 * how many pixels we pan & zoom by, per click.
	 * @const
	 * @type {number}
	 * @default
	 */
	ZOOM_SCALE: 20,

	/**
	 * How much we zoom on load
	 * @const
	 * @type {Number}
	 * @default
	 */
	ZOOM_TOLERANCE: 0.8,

	/**
	 * id of the DOM element the document viewer installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	DOCVIEW_CONTAINER_ID: 'docview',

	/**
	 * id of the DOM element the assetCheckinView installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	CHECKIN_CONTAINER_ID: 'asset-checkin',

	/**
	 * id of the file upload browse button in the assetCheckinView
	 * @const {string}
	 * @default
	 */
	CHECKIN_BROWSE_BUTTON_ID: 'asset-checkin-browse',

	/**
	 * id of the expiration asset list
	 * @const {string}
	 * @default
	 */
	EXPIRATION_ASSET_LIST_ID: 'expiration-assets',

	/**
	 * id of the expiration header
	 * @const {string}
	 * @default
	 */
	EXPIRATION_HEADER_ID: 'expiration-header',

	/**
	 * id the (non-modal) quick-edit panel (aka tag panel) installs in
	 * @const
	 * @type {string}
	 * @default
	 */
	TAGPANEL_CONTAINER_ID: 'quick-edit',

	/**
	 * max number of assets to show in the Most Viewed Assets list
	 * @const
	 * @type {number}
	 * @default
	 */
	MOST_VIEWED_SIZE: 40,

	/**
	 * ID of the upload button in assetViewsView
	 * @const
	 * @type {string}
	 * @default
	 */
	VIEW_UPLOAD_BUTTON_ID: 'asset-view-upload',

	/**
	 * id of the dom element where assetRepurposeView is installed
	 * @const
	 * @type {string}
	 * @default
	 */
	REPURPOSE_CONTAINER_ID: 'asset-repurpose',

	/**
	 * Array of the known asset detail tabs; disable a tab by removing it from this list.
	 * @const
	 * @type {array}
	 * @default
	 */
	DETAIL_TABS: [
		'overview',
		'preview',
		'fileinfo',
		'attributes',
		'attributeHistory',
		'views',
		'reviews',
		'links',
		'categories',
		'clips',
		'constituents_keyframes',
		'constituents_layers',
		'constituents_pages',
		'versions',
		'uasge',
		'index',
		'metadata',
		'permissions',
		'publicLinks',
	],

	/**
	 * Default tab of assetDetailView to show upon load
	 * @const
	 * @type {string}
	 * @default
	 */
	DETAIL_TABS_DEFAULT: 'fileinfo',

	/**
	 * max number of assets to show in the Recently Uploaded Assets list
	 * @const
	 * @type {number}
	 * @default
	 */
	RECENTLY_UPLOADED_SIZE: 40,

	/**
	 * Should we initialize the extra uploader for asset reimportation?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	REIMPORT_ENABLE: true,

	/**
	 * Should we initialize the extra uploader for asset checkin?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	CHECKIN_ENABLE: true,

	/**
	 * Should we initialize asset repurposing?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	REPURPOSE_ENABLE: true,

	/**
	 * Should we download an asset after checking it out?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	DOWNLOAD_ON_CHECKOUT: true,

	/**
	 * Is the CartAssets class extended from the MiniAssets class (instead of the Assets class)?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	// TODO: why is this in the asset controller instead of the cart controller?
	CART_ASSETS_MINI: true,

	/**
	 * Is the SearchAssets class extended from the MiniAssets class (instead of the Assets class)?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	// TODO: ditto previous question.
	SEARCH_ASSETS_MINI: true,

	/**
	 * Should we allow drag actions on assets?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	DRAGGABLE: true,

	/**
	 * Should assets re-fetch themselves immediately after saving to the DAM?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	FETCH_ON_SAVE: true,

	/**
	 * Should asset collections, by default, fetch via the Faceted Search interface instead of the standard Search interface?
	 * @const
	 * @type {boolean}
	 * @default
	 */
	USE_FACETED_SEARCH: false,
};
